import { Modals } from 'types/enums';

import { ModalPlaceholderInfo } from './interfaces';

export const MODAL_PLACEHOLDERS: ModalPlaceholderInfo = {
  [Modals.sectionSettings]: {
    view: 'side',
    withFooter: true,
  },
  [Modals.createSection]: {
    view: 'side',
    withFooter: true,
  },
  [Modals.createQuestion]: {
    size: 'md',
    view: 'side',
    withFooter: true,
  },
  [Modals.sectionSongIdeas]: {
    size: 'md',
    view: 'side',
  },
  [Modals.addSongsToSectionFromSearch]: {
    view: 'side',
  },
  [Modals.addSongsFromMusicSource]: {
    view: 'side',
  },
  [Modals.exportEventToSource]: {
    view: 'side',
  },
  [Modals.djNotes]: {
    view: 'side',
    withFooter: true,
  },
  [Modals.clone]: {
    size: 'sm',
    withFooter: true,
  },
  [Modals.pickImage]: {
    view: 'side',
    size: 'md',
  },
  [Modals.pickFiles]: {
    view: 'side',
    size: 'md',
  },
  [Modals.pickBrandingColor]: {
    view: 'side',
    size: 'md',
    withFooter: true,
  },
  [Modals.eventSettings]: {
    view: 'side',
    withFooter: true,
  },
  [Modals.addSongFromLink]: {
    view: 'side',
    withFooter: true,
  },
  [Modals.copySectionSettings]: {
    view: 'side',
    withFooter: true,
  },
};
